export const aboutHero  = {
  title: '关于颜轻至',
  subtitle: '麦杰集团旗下专业减肥纤体连锁品牌',
  description: '十余年深耕健康体重管理领域，从一家门店起步，逐步发展为覆盖多省市场的品牌连锁体系。我们坚持"绿色、高效、无忧"的服务理念，以专业、规范、长期的品牌形象赢得顾客与合作伙伴的信赖。',
  imagePrompt: 'Warm and bright modern wellness brand headquarters lobby with beige and cream color scheme, elegant reception area with subtle Chinese herbal elements, natural light streaming through large windows, professional yet welcoming atmosphere, architectural interior photography, clean minimal design',
};

export const timelineMilestones = [
  {
    year: '2013',
    title: '品牌创立',
    desc: '首家门店在西安正式开业，确立"绿色健康纤体"服务方向，迈出品牌化运营第一步。',
    icon: 'ri-seedling-line',
    bgPrompt: 'Subtle warm beige and cream abstract wallpaper texture with soft organic flowing lines, gentle gradient from cream to light warm brown, elegant minimalist wellness spa atmosphere, very subtle pattern, high-end interior design texture, ethereal soft focus',
  },
  {
    year: '2015',
    title: '夯实基础',
    desc: '完成直营体系搭建，建立标准化服务流程与培训机制，门店数量突破 10 家。',
    icon: 'ri-building-2-line',
    bgPrompt: 'Gentle warm beige and cream abstract wallpaper with subtle geometric foundation pattern, soft structured lines, calm organized aesthetic, professional wellness brand concept, very muted and subtle, high-end architectural texture',
  },
  {
    year: '2017',
    title: '省域拓展',
    desc: '深耕陕西市场，覆盖西安、咸阳、宝鸡等重点城市，区域品牌影响力持续提升。',
    icon: 'ri-map-pin-line',
    bgPrompt: 'Soft warm beige abstract wallpaper with subtle radial expansion pattern, gentle cream tones with barely visible map-like texture, atmospheric warm light, regional growth concept, very muted subtle design, elegant minimalist aesthetic',
  },
  {
    year: '2019',
    title: '加盟启航',
    desc: '推出标准化加盟合作模式，开启品牌连锁化发展新阶段，首批加盟门店顺利开业。',
    icon: 'ri-store-2-line',
    bgPrompt: 'Warm cream and beige abstract wallpaper with subtle interconnected nodes pattern, gentle partnership and network concept texture, soft golden warmth, elegant minimalist design, very muted and subtle, sophisticated business aesthetic',
  },
  {
    year: '2021',
    title: '跨省布局',
    desc: '业务版图扩展至河南、河北、山东、湖北等省份，建立区域管理团队与市场运营体系。',
    icon: 'ri-flight-takeoff-line',
    bgPrompt: 'Warm beige and cream abstract wallpaper with subtle landscape horizon texture, gentle layered terrain pattern, expansive soft atmospheric light, cross-regional growth concept, very muted and subtle, elegant aerial aesthetic',
  },
  {
    year: '2023',
    title: '数字升级',
    desc: '数字化运营管理系统全面上线，实现门店管理、顾客服务、数据追踪一体化，运营效率大幅提升。',
    icon: 'ri-computer-line',
    bgPrompt: 'Clean warm beige and cream abstract wallpaper with subtle digital grid pattern, very faint data visualization texture, soft modern tech aesthetic, elegant minimalist design, very muted and subtle, sophisticated digital concept',
  },
  {
    year: '2025',
    title: '品牌跃升',
    desc: '品牌全面升级，全国合作门店突破 200 家，完善区域经理、城市经理、门店店长三级管理体系。',
    icon: 'ri-medal-line',
    bgPrompt: 'Warm cream and beige abstract wallpaper with subtle elegant shimmer texture, gentle upward flow pattern, soft premium golden warmth, brand elevation concept, very muted and subtle, sophisticated luxury aesthetic',
  },
  {
    year: '2026',
    title: '持续深耕',
    desc: '深化服务标准化建设，拓展新市场，强化培训赋能体系，为更多顾客与合作伙伴创造价值。',
    icon: 'ri-rocket-line',
    bgPrompt: 'Warm beige and cream abstract wallpaper with subtle organic growth pattern, gentle upward spiraling texture, soft optimistic atmosphere, future-oriented concept, very muted and subtle, elegant progressive aesthetic',
  },
];

export const fiveCapabilities = [
  {
    icon: 'ri-flask-line',
    title: '产品研发',
    desc: '融合中医经络理论与现代健康科学，持续研发安全、温和、高效的草本护理与健康管理产品，从源头保障服务品质。',
    features: ['自主产品研发团队', '中医经络理论参考', '天然草本原料甄选', '持续产品迭代升级'],
  },
  {
    icon: 'ri-megaphone-line',
    title: '品牌推广',
    desc: '十余年品牌资产积累，统一品牌视觉与传播策略，线上线下协同推广，持续提升品牌知名度与市场影响力。',
    features: ['统一品牌视觉体系', '线上多渠道传播', '线下活动策划执行', '区域品牌协同推广'],
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '营销策划',
    desc: '总部与区域经理协同制定市场营销方案，从开业活动到日常引流，提供可落地的全套营销策划支持。',
    features: ['开业营销全案', '季度促销策划', '会员体系搭建', '私域流量运营'],
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '培训赋能',
    desc: '建立完善的培训体系，从产品知识、服务流程到门店管理，为门店店长、瘦身顾问提供持续系统化培训。',
    features: ['新店开业培训', '店长管理特训', '顾问服务进阶', '定期技能考核'],
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '售后服务',
    desc: '建立全周期售后服务体系，区域经理定期巡店指导，及时响应门店经营需求，保障顾客服务满意度。',
    features: ['区域经理定期巡店', '顾客满意度追踪', '门店运营诊断', '应急问题响应机制'],
  },
];

export const empowermentSystem = [
  {
    id: 'prod',
    title: '产品专业化',
    subtitle: 'PROFESSIONAL PRODUCTS',
    desc: '依托自主产品研发体系，确保每一款产品均经过严格筛选与科学验证，从配方到品质全程把控，为顾客提供安全可靠的护理体验。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'mgmt',
    title: '管理规范化',
    subtitle: 'STANDARDIZED MANAGEMENT',
    desc: '建立门店运营管理标准，涵盖人员管理、服务流程、环境卫生、顾客档案等全方位规范，确保每家门店服务品质统一。',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 'svc',
    title: '服务标准化',
    subtitle: 'STANDARDIZED SERVICE',
    desc: '制定从顾客进店到离店的完整服务标准流程，包括健康评估、方案沟通、服务实施、效果追踪等环节，让专业有据可依。',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'digital',
    title: '运营数字化',
    subtitle: 'DIGITAL OPERATIONS',
    desc: '借助数字化管理系统实现门店经营数据实时追踪、顾客档案云端管理、服务流程在线监控，以数据驱动运营决策。',
    icon: 'ri-smartphone-line',
  },
];

export const regions = [
  { name: '陕西', cities: '西安、咸阳、宝鸡、渭南、延安', isHeadquarters: true },
  { name: '河南', cities: '郑州、洛阳、南阳、新乡、信阳', isHeadquarters: false },
  { name: '河北', cities: '石家庄、保定、唐山、邯郸', isHeadquarters: false },
  { name: '黑龙江', cities: '哈尔滨、齐齐哈尔、大庆', isHeadquarters: false },
  { name: '江西', cities: '南昌、赣州、九江', isHeadquarters: false },
  { name: '山东', cities: '济南、青岛、烟台、潍坊、临沂', isHeadquarters: false },
  { name: '宁夏', cities: '银川、吴忠、石嘴山', isHeadquarters: false },
  { name: '湖北', cities: '武汉、襄阳、宜昌、荆州', isHeadquarters: false },
];

export const brandBeliefs = [
  {
    title: '品牌使命',
    desc: '让健康体重管理成为每个人触手可及的生活方式',
    icon: 'ri-flag-line',
  },
  {
    title: '品牌愿景',
    desc: '成为中国值得信赖的连锁健康纤体服务品牌',
    icon: 'ri-eye-line',
  },
  {
    title: '核心价值',
    desc: '专业为本、顾客为先、合作共赢、长期主义',
    icon: 'ri-star-line',
  },
];

export const corporateCulture = {
  mission: {
    title: '使命',
    description: '追求全体"颜轻至人"物质和精神两方面幸福的同时，帮助更多人塑造轻盈的体态、活力的生命和自信的人生，为健康中国的宏伟蓝图贡献伟大力量。',
    icon: 'ri-flag-2-line',
  },
  vision: {
    title: '愿景',
    description: '通过线下门店+大健康数据平台的方式打造健康生态，将"颜轻至"打造成全球体重管理与健康生活领域的绝对第一品牌。',
    icon: 'ri-eye-2-line',
  },
  values: [
    {
      title: '敬业爱岗',
      subtitle: '忠诚专业的职业素养',
      icon: 'ri-briefcase-line',
      desc: '以赤诚之心对待每一份工作，以专业精神服务每一位顾客。把岗位当舞台，把工作当事业，在平凡中追求卓越。',
    },
    {
      title: '开拓创新',
      subtitle: '独立自主的创新胆略',
      icon: 'ri-lightbulb-flash-line',
      desc: '敢于突破思维边界，勇于探索未知领域。以独立自主的姿态持续推动产品、服务、模式的全方位创新升级。',
    },
    {
      title: '乐于吃苦',
      subtitle: '不惧艰难的乐观主义',
      icon: 'ri-fire-line',
      desc: '以乐观的心态面对挑战，以坚韧的意志跨越困难。在逆境中磨砺成长，用笑容迎接每一次蜕变与新生。',
    },
    {
      title: '善于团结',
      subtitle: '顾全大局的集体主义',
      icon: 'ri-team-line',
      desc: '心往一处想，劲往一处使。以集体利益为重，以团队协作为荣，凝聚每一份力量共创品牌辉煌。',
    },
  ],
};